import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ServerRequest from "../../../exports/ServerRequest";
import SwiftModal from "../../CustomComponents/SwiftModal/SwiftModal";
import ConfirmBox from "../../CustomComponents/ConfirmBox/ConfirmBox";
import Pulse from "../../Loader/Pulse";
import {
  ArrowRight2,
  Cross,
  Edit,
  More,
  UserSearch,
} from "../../CustomComponents/SwiftIcon/Icons";
import { GetCookie } from "../../../exports/CookieManagement";
import { isEmpty, titleCase } from "../../../exports/UtilFunctions";
import { COLOR_VARS } from "../../../exports/ColorVars";
import CustomInputFile from "../../CustomComponents/CustomInputFile/CustomInputFile";
import CustomSelectError from "../../Body/CustomChartComponents/CustomSelectError/CustomSelectError";
import { Alert } from "../../Body/CustomChartComponents/CustomAlert/CustomAlert";

moment.updateLocale("language_code", { invalidDate: "-" });

const customerRoles = ["Managed Account Customer", "Broking Customer"];
const verticals = ["Equity", "Mutual Funds"];

const roleCodeMap = {
  "Super Admin": "SA",
  "Super User": "SU",
  Trader: "TRD",
  Operations: "OPR",
  Marketing: "MRK",
  "Trader & Operations": "TOU",
  "Trader & Marketing": "TMU",
  "Operations & Marketing": "OMU",
  "Trading & Operations & Marketing": "TMO",
  "Managed Account Customer": "MAC",
  "Broking Customer": "BRC",
};

function GetCustomerRoleTitle(role) {
  if (role == "BRC") return "Broking Customer";
  if (role == "MAC") return "Managed Customer";
  return "-";
}

const CustomerManagement = () => {
  const [popupImage, setPopupImage] = useState(null);
  const [data, setData] = useState([]);
  const [change, setChange] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [moreOptionsIndex, setMoreOptionsIndex] = useState(null);
  const [onboardCustomer, setOnboardCustomer] = useState(null);
  const [assignSuperuser, setAssignSuperuser] = useState(null);
  const [activateVertical, setActivateVertical] = useState(null);

  const token = GetCookie("admin_token");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data1 = await ServerRequest({
        url: `/admin/account/users?token=${token}`,
        method: "get",
      });
      if (data1.server_error) {
        navigate("/404", { state: { errorMessage: data1.message } });
      }

      const formattedData = data1.data.map((item) => {
        const sanitizedItem = Object.fromEntries(
          Object.entries(item).map(([key, value]) => [
            key,
            value === "" || value === "null" ? null : value,
          ])
        );

        const date = new Date(sanitizedItem.input_timestamp);
        return {
          ...sanitizedItem,
        };
      });

      setData(formattedData);

      setLoading(false);
    };
    fetchData();
    return () => {
      console.log("Cleanup");
    };
  }, [change]);

  const openPopup = async (imagePath) => {
    if (imagePath) {
      const encodedUrl = encodeURIComponent(imagePath);

      window.open(`/admin/image/${encodedUrl}`, "_blank");
    }
  };

  const closePopup = () => {
    setPopupImage(null);
  };
  const handleSubmit = async (item) => {
    const data = item;
    const myForm = new FormData();
    setLoading(true);

    Object.entries(data).forEach(([key, value]) => {
      myForm.append(key, value);
    });
    data.startemail = data.email;
    myForm.append("form", JSON.stringify(data));

    const data2 = await ServerRequest({
      url: `/admin/account/create?token=${token}`,
      data: myForm,
      method: "post",
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
    if (data2.server_error) {
      navigate("/404", { state: { errorMessage: data2.message } });
    }
    setLoading(false);
    setChange(Math.random());
  };

  const openForm = (item) => {
    if (item.status == "Deactivated" || item.role_type == "ADMIN") return;
    navigate(`/admin/form/${item.pan}`);
  };

  const showConfirmBox = (type, item) => {
    ConfirmBox({
      title: "Deactivate Customer Account",
      description: (
        <>
          <>Are you sure you want to {type.toLowerCase()} the account ?</>
        </>
      ),
      properties: [
        {
          id: "2",
          label: type,
          color: "#192b40",
          bgColor: "#ffffff",
          handleFunction: (callback) => {
            const data = item;
            data.status =
              data.status == "Deactivated" ? "Activated" : "Deactivated";
            handleSubmit(data);
            callback();
          },
        },
      ],
      cancel: true,
    });
  };

  const openconfirmPopup = (item) => {
    if (item.status == "Pending") return;
    showConfirmBox(
      item.status == "Deactivated" ? "Activate" : "Deactivate",
      item
    );
  };

  return !loading ? (
    <>
      <div className="swift-account-main open">
        <div className="swift-account-heading">
          <div className="select-search-wrapper">
            <div className="select-search-box">
              <input
                placeholder="Search Customer"
                value={filterData}
                onChange={(e) => setFilterData(e.target.value)}
              />
              <div className="filter-icon">
                <UserSearch size={20} color="#000" />
              </div>
            </div>
          </div>
        </div>

        {data.filter((item) =>
          item.name.toLowerCase().includes(filterData.toLowerCase())
        ).length > 0 ? (
          <div className="admin-wrapper full">
            <div className="admin-history-container admin-customer-container">
              <table>
                <thead>
                  <tr>
                    <td className="pan">Customer PAN</td>
                    <td className="mobile">Mobile Number</td>
                    <td className="email">Email Address</td>
                    <td className="name">Customer Name</td>
                    {/* <td className="pan-image">PAN Image</td> */}
                    <td className="registration-time">Registration Time</td>
                    <td className="status">Status</td>
                    <td className="role">Role</td>
                    {/* <td className="edit"></td> */}
                    {/* <td className="deactivate"></td> */}
                    <td className="action"></td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) =>
                    item.name
                      .toLowerCase()
                      .includes(filterData.toLowerCase()) ? (
                      <tr key={index}>
                        <td>{item.pan}</td>
                        <td>{item.mobile}</td>
                        <td>{item.primaryemail || item.email}</td>
                        <td>{titleCase(item.name)}</td>
                        {/* <td>
                        <button
                          className="swift-account-btn"
                          onClick={() => openPopup(item.pan_image)}
                        >
                          View
                        </button>
                      </td> */}
                        <td>
                          {moment(item.input_timestamp).format(
                            "MMM DD, YYYY HH:mm:ss"
                          )}
                        </td>
                        <td>{item.status}</td>
                        <td>
                          {!item.user_role
                            ? "-"
                            : GetCustomerRoleTitle(item.user_role)}
                        </td>
                        {/* <td>
                        <div
                          className="swift-account-svg"
                          onClick={
                            item.status === "Deactivated" ||
                            item.role_type === "ADMIN"
                              ? () => {}
                              : () => {
                                  openForm(item);
                                }
                          }
                        >
                          <Edit
                            size={18}
                            color={
                              item.status === "Deactivated" ||
                              item.role_type === "ADMIN"
                                ? COLOR_VARS["SWIFT_COLOR5"]
                                : COLOR_VARS["SWIFT_COLOR4"]
                            }
                          />
                        </div>
                      </td> */}
                        {/* <td>
                        <button
                          className={
                            "swift-account-btn " +
                            (item.status === "Pending" ? "disabled" : "")
                          }
                          onClick={() => {
                            openconfirmPopup(item);
                          }}
                        >
                          {item.status === "Deactivated"
                            ? "Activate"
                            : "Deactivate"}
                        </button>
                      </td> */}
                        <td className="more-menu-cell">
                          <div className="more-menu">
                            <div
                              className="swift-account-svg"
                              onClick={() => {
                                setMoreOptionsIndex(
                                  index == moreOptionsIndex ? null : index
                                );
                              }}
                            >
                              <More
                                size={18}
                                color={
                                  item.status === "Deactivated" ||
                                  item.role_type === "ADMIN"
                                    ? COLOR_VARS["SWIFT_COLOR5"]
                                    : COLOR_VARS["SWIFT_COLOR4"]
                                }
                              />
                            </div>
                            {index == moreOptionsIndex && (
                              <MoreOptions
                                data={item}
                                onboardUser={() => {
                                  setOnboardCustomer(item);
                                }}
                                assignSuperUser={() => {
                                  setAssignSuperuser(item);
                                }}
                                editUser={() => {
                                  openForm(item);
                                }}
                                activateVertical={() => {
                                  setActivateVertical(item);
                                }}
                                deactivateUser={() => {
                                  openconfirmPopup(item);
                                }}
                                closeMenu={() => {
                                  setMoreOptionsIndex(null);
                                }}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div
            className="swift-account-title"
            style={{
              alignSelf: "center",
              textAlign: "center",
              marginTop: "150px",
            }}
          >
            No Data Found
          </div>
        )}

        {popupImage && (
          <SwiftModal closeModal={closePopup} top="2%">
            <div className="popup-content">
              <img src={popupImage} alt="PAN Image" />
            </div>
          </SwiftModal>
        )}
      </div>
      {onboardCustomer && (
        <OnboardUserModal
          customer={onboardCustomer}
          closeModal={() => setOnboardCustomer(null)}
          setChange={setChange}
        />
      )}
      {assignSuperuser && (
        <AssignSuperuserModal
          customer={assignSuperuser}
          closeModal={() => {
            setAssignSuperuser(null);
          }}
          setChange={setChange}
        />
      )}

      {activateVertical && (
        <VerticalActivationModal
          customer={activateVertical}
          closeModal={() => {
            setActivateVertical(null);
          }}
          setChange={setChange}
        />
      )}
    </>
  ) : (
    <>
      <div className="admin-body-loader">
        <Pulse />
        <p>Loading data</p>
      </div>
    </>
  );
};

function OnboardUserModal({ customer, closeModal, setChange }) {
  const { name = "", pan = "" } = customer;

  const navigate = useNavigate();
  const token = GetCookie("admin_token");

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    customer_id: "",
    customer_password: "",
    user_role: "",
  });

  const [errors, setErrors] = useState({
    customer_id: "",
    customer_password: "",
    user_role: "",
  });

  async function fetchCustomerConfig(user_role) {
    if (!user_role) return;
    const data = await ServerRequest({
      url: `/admin/customer-id?account_code=${user_role}&token=${token}`,
      method: "get",
    });

    if (data.server_error) {
      navigate("/404", { state: { errorMessage: data.message } });
    }

    handleInputChange("customer_id", data.data.CustomerId);

    const firstName = name.split(" ")[0];
    const panDigits = pan.match(/\d+/)[0];
    const panFirstFourDigits = panDigits.slice(0, 4);
    const newPassword = `${firstName}@${panFirstFourDigits}`;

    handleInputChange("customer_password", newPassword);
  }

  async function handleSubmitActivate() {
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

    if (formData?.user_role == "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        user_role: "Select Customer Role",
      }));
    }

    if (formData?.customer_id == "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        customer_id: "Enter Valid Customer Id",
      }));
    }

    if (!regex.test(formData?.customer_password)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        customer_password: "Enter Valid Password",
      }));

      return;
    }

    setLoading(true);

    const payload = {
      pan: customer?.pan,
      mobile: customer?.mobile,
      name: customer?.name,
      email: customer?.email,
      user_role: formData.user_role,
      super_user_code: null,
      status: "Activated",
      startemail: customer?.email,
      customer_id: formData?.customer_id,
      customer_password: formData?.customer_password,
    };

    const data = await ServerRequest({
      url: `/admin/account/onboard?token=${token}`,
      data: payload,
      method: "post",
    });

    if (data.server_error) {
      navigate("/404", { state: { errorMessage: data.message } });
    } else {
      Alert({
        TitleText: "Success",
        Message: "Customer Onboarded Successfully",
        AutoClose: {
          Active: true,
          Line: true,
          Time: 3,
        },
      });
      setChange(Math.random());
    }

    setLoading(false);
    closeModal();
  }

  const handleInputChange = (name, value) => {
    setFormData((prevValues) => ({ ...prevValues, [name]: value }));
  };

  useEffect(() => {
    fetchCustomerConfig(formData?.user_role);
  }, [formData?.user_role]);

  return (
    <SwiftModal closeModal={closeModal} top="2%">
      <div className="swift-account-form swift-customer-form onboard-user-modal">
        {loading && (
          <>
            <div className="onboard-loader">
              <Pulse />
              <p>Creating Account</p>
            </div>
          </>
        )}
        <>
          <div className="swift-account-form-header">
            <div className="swift-account-form-title">Onboard User</div>
            <div className="swift-account-svg" onClick={closeModal}>
              <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
            </div>
          </div>
          <div className="swift-account-form-body">
            <div className="swift-account-form-body-content-extra popup-customer_id-form">
              <div className="swift-account-form-body-content">
                <CustomSelectError
                  heading="Customer Role"
                  placeholder="Please Select Customer Role"
                  defaultIndex={customerRoles.indexOf(formData["role_name"])}
                  options={customerRoles}
                  onTypeChange={(role) => {
                    handleInputChange("role_name", role);
                    handleInputChange("user_role", roleCodeMap[role]);
                  }}
                  error={errors.user_role}
                />
                <CustomInputFile
                  label="Customer ID"
                  name="customer_id"
                  type="text"
                  value={formData["customer_id"]}
                  onchange={handleInputChange}
                  error={errors.customer_id}
                  disabled={true}
                />
                <CustomInputFile
                  label="Customer Password"
                  name="customer_password"
                  type="text"
                  value={formData["customer_password"]}
                  onchange={handleInputChange}
                  error={errors.customer_password}
                />
              </div>
            </div>
            <div className="login-footer">
              <div className="swift-button-icon" onClick={handleSubmitActivate}>
                <div className="button-icon">
                  <ArrowRight2 size={20} color={COLOR_VARS["SWIFT_COLOR8"]} />
                </div>
                <p>Submit</p>
              </div>
            </div>
          </div>
        </>
      </div>
    </SwiftModal>
  );
}

function AssignSuperuserModal({ customer, closeModal, setChange }) {
  const token = GetCookie("admin_token");
  const [loading, setLoading] = useState(false);

  const [superusers, setSuperusers] = useState([]);

  const [schemes, setSchemes] = useState([]);
  const [currentScheme, setCurrentScheme] = useState([]);
  const [schemePopup, setSchemePopup] = useState(false);

  const [formData, setFormData] = useState({
    super_user_code: "",
    scheme_id: "",
    new_scheme: "",
  });

  const [errors, setErrors] = useState({
    super_user_code: "",
    scheme_id: "",
    scheme: "",
    new_scheme: "",
  });

  const handleInputChange = (name, value) => {
    setFormData((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        account_code: customer?.account_code,
        super_user_code: formData?.super_user_code,
        scheme_id: formData?.scheme_id,
        new_scheme: formData?.new_scheme,
      };
      const data = await ServerRequest({
        url: `/admin/account/assign-superuser?token=${token}`,
        data: payload,
        method: "post",
      });

      if (data.error) {
        Alert({
          TitleText: "Warning",
          Message: "Something went wrong",
          AutoClose: {
            Active: true,
            Line: true,
            Time: 3,
          },
        });
      } else {
        Alert({
          TitleText: "Success",
          Message: "Super User Assigned Successfully",
          AutoClose: {
            Active: true,
            Line: true,
            Time: 3,
          },
        });
        closeModal();
        setChange(Math.random());
      }
    } catch (error) {
      console.error("Error assigning super user:", error);
      Alert({
        TitleText: "Error",
        Message: "Something went wrong",
        AutoClose: {
          Active: true,
          Line: true,
          Time: 3,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const AddScheme = () => {
    if (isEmpty(formData.new_scheme)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        new_scheme: "Scheme name can not be empty",
      }));
      return;
    }
    const lowercasedNewScheme = formData.new_scheme.toLowerCase();
    if (
      schemes.some(
        (entry) => entry.scheme_name.toLowerCase() === lowercasedNewScheme
      )
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        new_scheme: "Scheme name already exists",
      }));
      return;
    }

    const newScheme = {
      scheme_id: Math.floor(Date.now() / 1000),
      scheme_owner: formData.super_user_code,
      scheme_name: formData.new_scheme,
      scheme_status: "active",
    };

    setSchemes((prev) => [...prev, newScheme]);
    setErrors((prevErrors) => ({
      ...prevErrors,
      new_scheme: "",
    }));

    setSchemePopup(false);
  };

  const fetchSuperUsers = async () => {
    const data = await ServerRequest({
      url: `/admin/account/superuser?token=${token}`,
      method: "get",
    });
    if (data.server_error) {
      setSuperusers([]);
    }
    const superusers = [
      { name: "No Super User", user_role: null, account_code: null },
      ...data.data,
    ];

    setSuperusers(superusers);
  };

  const fetchSchemes = async () => {
    const data = await ServerRequest({
      url: `/admin/account/schema?token=${token}`,
      method: "get",
    });
    if (data.server_error) {
      setSchemes([]);
    }
    setSchemes(data.data);
  };
  useEffect(() => {
    fetchSuperUsers();
    fetchSchemes();
  }, []);

  useEffect(() => {
    setFormData({
      super_user_code: customer?.super_user_code || "",
      scheme: customer?.scheme || "",
      scheme_id: customer?.scheme_id || "",
      new_scheme: "",
    });
  }, [customer]);

  useEffect(() => {
    if (formData !== null && formData !== undefined) {
      const filteredSchemes = schemes.filter((entry) => {
        return (
          entry.scheme_owner === formData.super_user_code &&
          entry.scheme_status === "active"
        );
      });
      setCurrentScheme(filteredSchemes);
    }
  }, [formData.super_user_code, schemes]);

  return (
    <>
      {schemePopup ? (
        <SwiftModal closeModal={() => setSchemePopup(false)}>
          <div className="swift-account-form swift-customer-form">
            {loading ? (
              <>
                <div className="loader">
                  <Pulse />
                  <p>Creating Account</p>
                </div>
              </>
            ) : (
              <>
                <div className="swift-account-form-header">
                  <div className="swift-account-form-title">
                    Portfolio Scheme
                  </div>
                  <div
                    className="swift-account-svg"
                    onClick={() => setSchemePopup(false)}
                  >
                    <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                  </div>
                </div>
                <div className="swift-account-form-body">
                  <div className="swift-account-form-body-content-extra popup-customer_id-form">
                    <div className="swift-account-form-body-content">
                      <CustomInputFile
                        label="Portfolio Scheme"
                        name="new_scheme"
                        type="text"
                        value={formData["new_scheme"]}
                        onchange={handleInputChange}
                        error={errors.new_scheme}
                      />
                    </div>
                  </div>
                  <div className="login-footer">
                    <div className="swift-button-icon" onClick={AddScheme}>
                      <div className="button-icon">
                        <ArrowRight2 size={20} color={COLOR_VARS["SWIFT_COLOR8"]} />
                      </div>
                      <p>Submit</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </SwiftModal>
      ) : (
        <>
          <SwiftModal closeModal={closeModal}>
            <div className="swift-account-form swift-customer-form assign-superuser-modal">
              {loading && (
                <>
                  <div className="superuser-loader">
                    <Pulse />
                  </div>
                </>
              )}
              <>
                <div className="swift-account-form-header">
                  <div className="swift-account-form-title">
                    Assign Super User
                  </div>
                  <div className="swift-account-svg" onClick={closeModal}>
                    <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                  </div>
                </div>
                <div className="swift-account-form-body">
                  <div className="swift-account-form-body-content-extra popup-customer_id-form">
                    <div className="swift-account-form-body-content">
                      <CustomSelectError
                        heading="Super User Code"
                        placeholder="Please Select Super User Code"
                        defaultIndex={superusers
                          .map((item) => item.account_code)
                          .indexOf(formData["super_user_code"])}
                        options={superusers.map((item) => item.name)}
                        onTypeChange={(su) => {
                          const selectedSuperUser = superusers.find(
                            (user) => user.name === su
                          );
                          if (selectedSuperUser) {
                            handleInputChange(
                              "super_user_code",
                              selectedSuperUser.account_code
                            );
                          }
                        }}
                        error={errors.super_user_code}
                      />
                      {formData.super_user_code && (
                        <>
                          <CustomSelectError
                            heading="Portfolio Scheme"
                            placeholder="Select Scheme"
                            defaultIndex={currentScheme
                              .map((item) => item.scheme_name)
                              .indexOf(formData.scheme)}
                            options={currentScheme.map(
                              (entry) => entry.scheme_name
                            )}
                            onTypeChange={(role) => {
                              handleInputChange("scheme", role);
                              const matchedScheme = schemes.find(
                                (scheme) => scheme.scheme_name === role
                              );
                              handleInputChange(
                                "scheme_id",
                                matchedScheme.scheme_id
                              );
                            }}
                            error={errors.user_role}
                          />
                          <button
                            className="swift-account-btn add-scheme-btn"
                            onClick={() => setSchemePopup(true)}
                          >
                            Add Scheme
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="login-footer">
                    <div className="swift-button-icon" onClick={handleSubmit}>
                      <div className="button-icon">
                        <ArrowRight2 size={20} color={COLOR_VARS["SWIFT_COLOR8"]} />
                      </div>
                      <p>Submit</p>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </SwiftModal>
        </>
      )}
    </>
  );
}

function VerticalActivationModal({ customer, closeModal, setChange }) {
  const token = GetCookie("admin_token");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    vertical: "",
  });

  const [errors, setErrors] = useState({
    vertical: "",
  });

  const handleInputChange = (name, value) => {
    setFormData((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const getVerticalValue = (vertical) => {
    const verticalMap = {
      Equity: "equity",
      "Mutual Funds": "mutual_funds",
    };
    return verticalMap[vertical] || "";
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (formData?.vertical == "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          vertical: "Select Vertical",
        }));
        return;
      }

      const v = getVerticalValue(formData?.vertical);

      if (!v) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          vertical: "Invalid Vertical",
        }));
        return;
      }

      const payload = {
        account_code: customer?.account_code,
        vertical: v,
      };
      const data = await ServerRequest({
        url: `/admin/account/vertical-activation-request?token=${token}`,
        data: payload,
        method: "post",
      });

      if (data.error) {
        Alert({
          TitleText: "Warning",
          Message: data?.message || "Something went wrong",
          AutoClose: {
            Active: true,
            Line: true,
            Time: 3,
          },
        });
      } else {
        Alert({
          TitleText: "Success",
          Message: "Vertical Activation Requested Successfully",
          AutoClose: {
            Active: true,
            Line: true,
            Time: 3,
          },
        });
        closeModal();
        setChange(Math.random());
      }
    } catch (error) {
      console.error("Error activating vertical:", error);
      Alert({
        TitleText: "Error",
        Message: "Something went wrong",
        AutoClose: {
          Active: true,
          Line: true,
          Time: 3,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SwiftModal closeModal={closeModal}>
      <div className="swift-account-form swift-customer-form assign-superuser-modal">
        {loading && (
          <>
            <div className="superuser-loader">
              <Pulse />
            </div>
          </>
        )}
        <>
          <div className="swift-account-form-header">
            <div className="swift-account-form-title">
              Vertical Activation Request
            </div>
            <div className="swift-account-svg" onClick={closeModal}>
              <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
            </div>
          </div>
          <div className="swift-account-form-body">
            <CustomSelectError
              heading="Select Vertical"
              placeholder="Please Select Vertical"
              defaultIndex={verticals.indexOf(formData["vertical"])}
              options={verticals}
              onTypeChange={(v) => {
                handleInputChange("vertical", v);
              }}
              error={errors.vertical}
            />
            <div className="login-footer">
              <div className="swift-button-icon" onClick={handleSubmit}>
                <div className="button-icon">
                  <ArrowRight2 size={20} color={COLOR_VARS["SWIFT_COLOR8"]} />
                </div>
                <p>Submit</p>
              </div>
            </div>
          </div>
        </>
      </div>
    </SwiftModal>
  );
}

function MoreOptions({
  data,
  onboardUser,
  assignSuperUser,
  editUser,
  deactivateUser,
  activateVertical,
  closeMenu,
}) {
  const { status = "", role_type = "" } = data;

  const optionsRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      setTimeout(() => {
        if (optionsRef.current && !optionsRef.current.contains(event.target)) {
          closeMenu();
        }
      }, 0);
    };

    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, []);

  return (
    <div className="more-menu-options" ref={optionsRef}>
      {(!status || status === "Pending") && (
        <div onClick={onboardUser}>Onboard User</div>
      )}
      {!status ||
      status === "Deactivated" ||
      status === "Pending" ||
      role_type === "ADMIN" ? (
        <></>
      ) : (
        <>
          <div onClick={editUser}>Edit User</div>
        </>
      )}
      {data?.account_code && (
        <div onClick={assignSuperUser}>Assign Super User</div>
      )}
      {data?.account_code && (
        <div onClick={activateVertical}>Vertical Activation Request</div>
      )}
      {(status === "Activated" || status === "Deactivated") && (
        <>
          <div onClick={deactivateUser}>
            {status === "Deactivated" ? "Activate User" : "Deactivate User"}
          </div>
        </>
      )}
    </div>
  );
}

export default CustomerManagement;
